module.exports = __webpack_public_path__ + "static/img/s8.5c28758.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/eng/s8.png
// module id = wi69
// module chunks = 0